import React from "react";
import { Construction } from "lucide-react";

/**
 * EmptyState — used for routes that render before their own data
 * is available OR for permission-denied fallbacks. Product-language
 * only; no phase/wave labels ever surface here.
 */
export default function EmptyState({ title, note }) {
  return (
    <div className="max-w-4xl mx-auto px-8 py-10">
      <div className="mb-8">
        <h1 className="font-display text-3xl text-deep-road-navy tracking-tight">
          {title}
        </h1>
        <div className="w-16 h-[3px] bg-coach-blue mt-2" />
      </div>

      <div
        data-testid={`empty-state-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        className="bg-white border border-coach-silver rounded-md p-10"
      >
        <div className="flex items-start gap-5">
          <div className="w-11 h-11 rounded-md bg-road-white border border-coach-silver grid place-items-center text-coach-blue">
            <Construction size={20} />
          </div>
          <div className="flex-1">
            <div className="text-carbon text-[15px] leading-relaxed">
              {note || "This workspace has no items to display right now."}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
